var _g, _g2, _g3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#1d3faa",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.61,56.07A16.61,16.61,0,0,0,32,39.45h0A16.61,16.61,0,0,0,15.39,56.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.41,28a8.11,8.11,0,0,1-8.25,8.1,8.28,8.28,0,0,1-7.95-8.37V16.45a.06.06,0,0,1,.05-.06,60.56,60.56,0,0,1,8.27-.68,54.93,54.93,0,0,1,7.91.68.06.06,0,0,1,.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.21,20.14l-8.27-3.8a.08.08,0,0,1,0-.13L31.32,8.39h.06l16.33,7.74a.07.07,0,0,1,0,.12L39.5,20.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.21,24.35H20.89s-2,0-2,3.1c0,2.86,2,2.86,2,2.86l2.72,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.41,24.71h2.32s2,0,2,3.09c0,2.86-2,2.86-2,2.86H39"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.85,
    y1: 33.15,
    x2: 46.85,
    y2: 16.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.85,
    cy: 35.28,
    r: 2.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,23a42.89,42.89,0,0,0-7.95-.69,40.85,40.85,0,0,0-8.34.69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStudents);
export default __webpack_public_path__ + "static/media/total-students.bbeaf1201a2b8d45feda69701a438546.svg";
export { ForwardRef as ReactComponent };